import React, {FC} from 'react';
import {useFormik} from 'formik';
import {useStoreon} from 'storeon/react';
import cnBind from 'classnames/bind';
import dayjs from 'dayjs';
import {GxButton, GxForm, GxInput} from '@garpix/garpix-web-components-react';
import { toast } from 'react-toastify';
import styles from './styles/index.module.scss';
import Radio from '../../../../components/Radio';
import {PAYMENT_RETURN_PAY_ITEMS} from '../ModalOrder/const';
import InputNumbers from '../../../../components/InputNumbers';
import {ORDERS} from '../../../../const';
import ModalLayout from '../../../../components/ModalLayout';
import {returnDeposit} from '../../helpers';
import { IDepositInfo } from '../ModalUser/types';

interface IReturnDeposit {
    flag: boolean;
    onRequestClose: () => void;
    data: IDepositInfo,
    userInfo: Record<string, any> | null
    updateDepositData: (deposit_id: number) => void;
}

const ReturnDeposit: FC<IReturnDeposit> = ({onRequestClose, flag, data, userInfo, updateDepositData}) => {
    const cn = cnBind.bind(styles);
    const {data: dataDeposit, type} = data;
    const {dispatch} = useStoreon();
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {amount: 0, comment: '', resource_amount: 0, return_method: null, date: null},
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: async (values) => {
            if (values.return_method === null) {
                return
            }

            await returnDeposit({
                deposit_id: dataDeposit?.id,
                resource: values.resource_amount,
                return_method: values.return_method,
                comment: values.comment
            }).then(() => {
                dispatch('depositListUser/get', {user_id: userInfo?.id, is_has_resource: true});
                updateDepositData(dataDeposit?.id);
                formik.handleReset(values);
                onRequestClose();
            }, () => {
                dispatch('depositListUser/get', {user_id: userInfo?.id, is_has_resource: true});
                updateDepositData(dataDeposit?.id);
                toast.error('Не удалось произвести возврат');
            })
        }
    });

    const handleOnPressKey =(e:React.KeyboardEvent<HTMLElement>)=>{
      if (!new RegExp(/[0-9]/).test(e.key)) {
        e.preventDefault();
      }  
    }

    const cancel = (e?: any) =>{
        formik.handleReset(e);
        onRequestClose()
    }

  const sumDecimalCorrection = (value: number) => {
    if (!dataDeposit || !dataDeposit.resource_price) {
      return 0
    }
    

    if (!value) {
      return 0
    }
    

    if (data.type === ORDERS.PIPE) {
      if (value === data?.data?.minutes) {
        return Number(dataDeposit.balance?.toLocaleString());
      }
      return (dataDeposit.resource_price * value).toLocaleString();
    }

    if (dataDeposit && value === dataDeposit?.sets) {
      return Number(dataDeposit?.balance?.toLocaleString());
    }
    return (dataDeposit.resource_price * value).toLocaleString();
  }

  const resourceType = () => {
    const value = data?.type === ORDERS.PIPE
      ? dataDeposit?.minutes?.toLocaleString()
      : dataDeposit?.rent_pay_count || dataDeposit.sets

    const label = data.type === ORDERS.PIPE
      ? 'мин.'
      : dataDeposit?.rent_pay_count ? 'ap.' : 'сет(ов)'

    return `${value} ${label}`
  }

    return (
        <ModalLayout
            flag={flag}
            onClose={cancel}
        >
            <div className={styles['header']}>
                <h2 className={styles['header--title']}>Возврат средств. Счет №{data?.data?.pay_order_id}</h2>
                <div className={styles['header--info']}>
                    <span>Кому: {userInfo ? userInfo.last_name : ''} {userInfo ? userInfo.first_name : ''} </span>
                </div>
            </div>

        <GxForm onGx-submit={formik.submitForm}>
            <div className={styles['subheader']}>
                <span className={styles['subheader--subtitle']}>Способ возврата:</span>
            </div>
            <div className={styles['actions']}>
                {PAYMENT_RETURN_PAY_ITEMS
                    // .filter((item) => (is_pay_here || certificate_name || deposit_name) ? item.id !== RETURN_PAY_TYPES.ONLINE : true)
                    .map((item) => (
                        <Radio
                            key={item.id}
                            name="return_method" className={styles['actions--item']}
                            checked={formik.values.return_method === item.id}
                            onClick={() => formik.setFieldValue('return_method', item.id)}>
                            {item.title}
                        </Radio>
                    ))}
            </div>
            <div className={styles['wrap-group']}>
                <div className={styles['group']}>
                    <InputNumbers
                      label='Сумма возврата:'
                      name="amount"
                      value={formik.values.amount}
                      disabled
                      className={cn({
                          'group--input': true,
                          'group--input--error': formik.errors.amount
                      })}
                      type='number'
                    />
                    <span className={styles['symbol--price']}/>
                    <p className={styles['group--error']}>{formik.errors.amount}</p>
                </div>
                <div className={styles['group']}>
                    <GxInput
                      label='Примечание:'
                      name="comment"
                      onGx-change={(e: Record<string, any>) => {
                          formik.setFieldValue('comment', e.target.value);
                      }}
                      className={cn(styles['group--input'])}
                    />
                </div>
                    <div className={styles['group']}>
                        <InputNumbers
                            label='Возвращаемый ресурс:'
                            name="resource_amount"
                            onKeyPress={handleOnPressKey}
                            value={formik.values.resource_amount}
                            handleInput={(e:Record<string, any>)=>{
                                formik.setFieldValue('resource_amount', e.target.value)
                                formik.setFieldValue('amount', sumDecimalCorrection(+e.target.value))
                            }}
                            className={cn({
                                'group--input': true,
                                'group--input--error': formik.errors.resource_amount
                            })}
                            type='number'
                        />
                        <span className={styles['symbol--resurs']}>
                            {type === ORDERS.PIPE 
                                ? 'мин.' 
                                : dataDeposit?.rent_pay_count
                                    ? 'ap.' 
                                    : 'сет(ов)'}
                        </span>
                        <p className={styles['group--error']}>{formik.errors.amount}</p>
                    </div>
            </div>
            <div className={styles['footer']}>
                <div className={styles['footer--left-block']}>
                    <div className={styles['pay-info']}>
                        <div className={styles['pay-info__item']}>
                            <p className={styles['pay-info__item_label']}>Ден. экв. депозита:</p>
                            <p className={styles['pay-info__item_text']}>{dataDeposit?.balance.toLocaleString()} ₽</p>
                        </div>
                        <div className={cn(styles['pay-info__item'], styles['pay-info__item_paid'])}>
                            <p className={styles['pay-info__item_label']}>Оставшийся ресурс:&#32;</p>
                                <p className={styles['pay-info__item_text']} >
                                {resourceType}
                                </p>
                        </div>
                    </div>
                </div>
                <div className={styles['time']}>
                    <p className={styles['time--info']}>Дата создания счета:</p>
                    <p className={styles['time--date']}>{data?.data?.pay_order_created_at && dayjs(data?.data?.pay_order_created_at).format('YYYY-MM-DD HH:mm')}</p>
                </div>
                <div className={styles['footer--right-block']}>
                    <GxButton className={styles['btn--gray']} onClick={cancel}>
                        Отмена
                    </GxButton>
                    <GxButton className={styles['btn--default']} type='submit' disabled={formik.values.return_method === null}>
                        Вернуть
                    </GxButton>
                </div>
            </div>
        </GxForm>
        </ModalLayout>
    );
};

export default ReturnDeposit;